import { useEffect, useState } from 'react';
import { WifiOff } from 'lucide-react';
import { AnnouncementBand } from '@/design/components';

/** פס עליון "אין חיבור". פעולות כתיבה לא נשמרות בתור (מסמך התכנון, סעיף 4.5). */
export function OfflineBand() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const online = () => setIsOnline(true);
    const offline = () => setIsOnline(false);
    window.addEventListener('online', online);
    window.addEventListener('offline', offline);
    return () => {
      window.removeEventListener('online', online);
      window.removeEventListener('offline', offline);
    };
  }, []);

  if (isOnline) return null;
  return <AnnouncementBand icon={WifiOff}>אין חיבור. מוצגים נתונים שנשמרו במכשיר.</AnnouncementBand>;
}
